import actions from './actions'
import mutations from './mutations'

const paymentLogs = {
    namespaced: true,
    state: {
        paymentLogs: [],
        isLoaded: true
    },
    mutations,
    actions
}

export default paymentLogs
